import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import camelCaseToKebab from "@shared/functions/camelCaseToKebab";
import { Field } from "formik";

interface Props
	extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "name"> {
	children: React.ReactNode;
	name: string;
}

export default function Select({ children, ...props }: Props) {
	if (!props.id) {
		props.id = camelCaseToKebab(props.name);
	}

	return (
		<div className="select-wrapper">
			<Field as="select" className="form__input" required {...props}>
				{children}
			</Field>
			<FontAwesomeIcon icon={faChevronDown} />
		</div>
	);
}
